import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const heatmapTool: Tool = {
  id: "heatmap",
  name: () => m.heat_tool_name(),
  description: () => m.heat_tool_description(),
  icon: "🔥",
  basePath: "/heatmap",
  status: "stable",
  tags: ["chart", "plot", "data-visualization", "heatmap", "science"],
};
